import { createSlice, combineReducers, createAsyncThunk } from '@reduxjs/toolkit'
import { NBGRate, CommercialRate } from '@lk/api'

import { loadNBGRates, loadCommercialRates } from './rates.actions'

interface RatesState<T> {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string
  data: T | null
}

function getInitialRatesState<T>(): RatesState<T> {
  return {
    status: 'idle',
    error: null,
    data: null,
  }
}

function createRatesSlice<T>(name: string, asyncAction: ReturnType<typeof createAsyncThunk>) {
  return createSlice({
    name,
    initialState: getInitialRatesState<T>(),
    reducers: {},
    extraReducers: {
      [asyncAction.pending.toString()]: (state) => {
        state.status = 'loading'
      },
      [asyncAction.fulfilled.toString()]: (state, action) => {
        state.status = 'loaded'
        state.data = action.payload
      },
      [asyncAction.rejected.toString()]: (state, action) => {
        state.status = 'failed'
        state.error = action.payload
      },
    },
  }).reducer
}

export const ratesReducer = combineReducers({
  nbg: createRatesSlice<NBGRate[]>('nbgRates', loadNBGRates),
  commercial: createRatesSlice<CommercialRate[]>('commercialRates', loadCommercialRates),
})
